import React from "react";
import { useTranslation, Trans } from "react-i18next";

import {
  Modal,
  Image
} from '@lockerpm/design';

import ResubmitIcon from '../../../../../assets/images/icons/resubmit.svg'

const ResubmitModal = (props) => {
  const { t } = useTranslation();
  const {
    visible = false,
    modalData = {
      action: '',
      store: '',
    },
    onClose = () => {},
  } = props;

  return (
    <Modal
      title={<></>}
      open={visible}
      width={430}
      footer={false}
      onCancel={() => onClose()}
    >
      <div className="flex items-center justify-center">
        <Image
          src={ResubmitIcon}
          preview={false}
        />
      </div>
      <div className="text-center mt-5">
        {
          !['Capterra', 'Clutch', 'G2'].includes(modalData.store) && <div className="text-xl font-semibold mb-5">
            {t('rewards.verify_popup.resubmit.title') }
          </div>
        }
        {
          modalData.store === 'extension' && <div>
            <Trans
              i18nKey={'rewards.verify_popup.resubmit.desc1'}
              values={{
                action: modalData.action,
              }}
              components={{
                b: <b className="font-semibold"/>
              }}
            />
          </div>
        }
        {
          modalData.store === 'desktop' && <div>
            <Trans
              i18nKey={'rewards.verify_popup.resubmit.desc3'}
              values={{
                action: modalData.action,
              }}
              components={{
                b: <b className="font-semibold"/>
              }}
            />
          </div>
        }
        {
          ['App Store', 'Google Play'].includes(modalData.store) && <div>
            <Trans
              i18nKey={'rewards.verify_popup.resubmit.desc'}
              values={{
                action: modalData.action,
                store: modalData.store
              }}
              components={{
                b: <b className="font-semibold"/>
              }}
            />
          </div>
        }
        {
          ['Capterra', 'Clutch', 'G2'].includes(modalData.store) && <div>
            <Trans
              i18nKey={'rewards.verify_popup.resubmit.desc4'}
              values={{
                store: modalData.store
              }}
              components={{
                b: <b className="font-semibold"/>
              }}
            />
          </div>
        }
        {
          !['Capterra', 'Clutch', 'G2'].includes(modalData.store) && <div className="mt-2">
            <Trans
              i18nKey={'rewards.verify_popup.resubmit.desc2'}
              components={{
                a: <a className="font-semibold"/>
              }}
            />
          </div>
        }
      </div>
    </Modal>
  );
}

export default ResubmitModal;